const levels = {
  level_1: "1. Seviye",
  level_2: "2. Seviye",
  level_3: "3. Seviye Eğitmen",
  mastery: "Ustalık Seviyesi",
};

export default function AudienceSelector({ value, onChange, clients = [] }) {
  const update = (patch) => onChange({ ...value, ...patch });
  const toggleLevel = (level) => {
    const selected = value.target_levels || [];
    update({
      target_levels: selected.includes(level)
        ? selected.filter((item) => item !== level)
        : [...selected, level],
    });
  };
  return (
    <fieldset className="border border-pleiades-border bg-pleiades-ivory p-3">
      <legend className="px-1 text-[11px] font-semibold text-pleiades-ink">Kimler görebilir?</legend>
      <select
        aria-label="İçerik hedef kitlesi"
        value={value.audience}
        onChange={(event) => update({ audience: event.target.value, target_levels: [], client_id: "" })}
        className="input"
      >
        <option value="all">Tüm portal kullanıcıları</option>
        <option value="levels">Yalnız seçilen uygulayıcı seviyeleri</option>
        <option value="client">Yalnız belirli danışan</option>
      </select>
      {value.audience === "levels" && (
        <div className="mt-3 flex flex-wrap gap-2">
          {Object.entries(levels).map(([key, label]) => (
            <label key={key} className={`flex min-h-11 cursor-pointer items-center gap-2 border px-3 text-[12px] ${value.target_levels?.includes(key) ? "border-pleiades-blue bg-pleiades-blue-soft text-pleiades-blue" : "border-pleiades-border bg-white"}`}>
              <input aria-label={label} type="checkbox" checked={value.target_levels?.includes(key) || false} onChange={() => toggleLevel(key)} />
              {label}
            </label>
          ))}
        </div>
      )}
      {value.audience === "client" && (
        <select aria-label="Belirli danışan" required value={value.client_id || ""} onChange={(event) => update({ client_id: event.target.value })} className="input mt-3">
          <option value="">Danışan seçin</option>
          {clients.map((client) => <option key={client.id} value={client.id}>{client.full_name} · {client.email || "E-posta yok"}</option>)}
        </select>
      )}
      <p className="mt-2 text-[10px] leading-relaxed text-pleiades-slate">
        {value.audience === "all" && "Yeni gelen ve onaysız kullanıcılar dahil herkes görür."}
        {value.audience === "levels" && "Yalnız onaylı ve seçilen seviyedeki uygulayıcılar görür."}
        {value.audience === "client" && "Yalnız seçtiğiniz danışanın hesabında görünür."}
      </p>
    </fieldset>
  );
}

export function audienceLabel(item, clients = []) {
  if (item.audience === "all") return "Tüm kullanıcılar";
  if (item.audience === "client") return clients.find((client) => client.id === item.client_id)?.full_name || "Belirli danışan";
  return (item.target_levels || []).map((level) => levels[level]).join(", ") || "Seviye seçilmemiş";
}
